module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/boxes-ac1acaebe8726f7a7c2612f3bb32a116.png";